/**
 * DelegatedDisconnectedState
 *
 * Empty-state exibido no lugar do inbox quando o usuário está num workspace
 * DELEGADO cujo WhatsApp não está conectado. A conexão pertence ao dono do
 * workspace — por isso NÃO há ação de conectar aqui, apenas o caminho de
 * volta para a grade de workspaces.
 *
 * Props:
 *   - workspaceName: string — nome do dono do workspace
 *     (caller passa getDelegation()?.targetName; fallback "este usuário")
 */
import { WifiOff } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import { isEmbedded } from '../../utils/embed';

const DelegatedDisconnectedState = ({ workspaceName }) => {
  const { colors } = useTheme();
  const name = workspaceName || 'este usuário';

  const styles = {
    container: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '14px',
      padding: '32px',
      textAlign: 'center',
    },
    iconCircle: {
      width: '64px',
      height: '64px',
      borderRadius: '50%',
      backgroundColor: `${colors.accentPrimary}1f`,
      color: colors.accentPrimary,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    title: {
      fontSize: '17px',
      fontWeight: 700,
      color: colors.textPrimary,
    },
    text: {
      fontSize: '14px',
      color: colors.textSecondary,
      lineHeight: 1.55,
      maxWidth: '380px',
    },
    backBtn: {
      marginTop: '6px',
      padding: '9px 18px',
      borderRadius: '10px',
      border: `1px solid ${colors.borderColor}`,
      backgroundColor: colors.bgPrimary,
      color: colors.textPrimary,
      fontSize: '13px',
      fontWeight: 600,
      cursor: 'pointer',
      transition: 'opacity 0.15s ease',
    },
  };

  // CRM embutido em painel parceiro (2026-10-22): a conexão do número não
  // roda dentro do iframe (Meta e Instagram recusam ser embutidos). O botão
  // abre a InfinitSales numa aba própria, onde o dono conecta.
  const embutido = isEmbedded();

  return (
    <div style={styles.container}>
      <div style={styles.iconCircle}>
        <WifiOff size={28} />
      </div>
      <div style={styles.title}>
        {embutido ? 'O WhatsApp ainda não está conectado' : 'Este workspace ainda não conectou o WhatsApp'}
      </div>
      <div style={styles.text}>
        {embutido
          ? 'A conexão do número é feita na InfinitSales. Depois de conectar, as conversas aparecem aqui.'
          : `Peça para ${name} conectar o número, ou volte para os workspaces.`}
      </div>
      <button
        style={styles.backBtn}
        onClick={() => {
          if (embutido) {
            window.open(`${window.location.origin}${window.location.pathname}`, '_blank', 'noopener');
            return;
          }
          window.location.href = '/empresa';
        }}
        onMouseEnter={(e) => { e.currentTarget.style.opacity = '0.85'; }}
        onMouseLeave={(e) => { e.currentTarget.style.opacity = '1'; }}
      >
        {embutido ? 'Abrir a InfinitSales' : 'Voltar aos workspaces'}
      </button>
    </div>
  );
};

export default DelegatedDisconnectedState;
